import React from 'react';

const footer = ()=> {
	return(
		<div class="copyright-txt mt-3 mb-3">
      <small class="text-left text-muted">
        Copyright &copy; 2025 by AuthBridge. All Rights Reserved |
        <a href="https://ibridge.authbridge.com/home/privacy-policy/" target="_">
          {" "}
          Privacy policy
        </a>
      </small>
    </div>
	)
}

export default footer;